export const aciArrowBack = {
    iconName: 'arrow-back',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M23.25 12.106A2.25 2.25 0 0021 9.856H8.432L11.485 6.8A2.25 2.25 0 008.3 3.62l-6.891 6.895a2.25 2.25 0 000 3.182L8.3 20.591a2.25 2.25 0 103.182-3.182l-3.05-3.053H21a2.25 2.25 0 002.25-2.25z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
